import { z } from "zod/v4";

import {
  StayAiExperienceSettingsType,
  StayAiGlobalSettingsType,
} from "../schemas/stay-ai";

import {
  GoogleExperienceSettingsType,
  GoogleGlobalSettingsDto,
} from "./google-integrations";
import {
  GrowLTVExperienceSettingsType,
  GrowLTVGlobalSettingsDto,
} from "./grow-ltv-integrations";
import {
  BaseIntegrationDto,
  BaseIntegrationDtoSchema,
  CreateBaseIntegrationDtoSchema,
  IntegrationName,
} from "./integrations";
import {
  OneClickUpsellExperienceSettingsDto,
  OneClickUpsellGlobalSettingsDto,
} from "./oneclick-upsell-integrations";
import {
  RechargeExperienceSettingsDto,
  RechargeGlobalSettingsDto,
} from "./recharge-integrations";

export const ExperienceIntegrationDtoSchema = z.object({
  id: z.uuid(),
  createdAtTs: z.number(),
  integration: BaseIntegrationDtoSchema,
  experienceSettings: z.any(),
  enabled: z.boolean().default(false),
});

export const CreateExperienceIntegrationDtoSchema =
  ExperienceIntegrationDtoSchema.omit({
    createdAtTs: true,
  }).extend({
    id: z.uuid().optional(),
    integration: CreateBaseIntegrationDtoSchema,
  });

export type CreateExperienceIntegrationDto = z.infer<
  typeof CreateExperienceIntegrationDtoSchema
>;

export interface ExperienceIntegrationDto<
  Name = IntegrationName,
  GlobalSettings = object,
  ExperienceSettings = object,
> {
  id: string;
  enabled: boolean;
  createdAtTs: number;
  integration: BaseIntegrationDto & {
    name: Name;
    globalSettings: GlobalSettings;
  };
  experienceSettings: ExperienceSettings;
}

export type GoogleExperienceIntegrationDto = ExperienceIntegrationDto<
  "Google",
  GoogleGlobalSettingsDto,
  GoogleExperienceSettingsType
>;

export type StayAiExperienceIntegrationDto = ExperienceIntegrationDto<
  "StayAi",
  StayAiGlobalSettingsType,
  StayAiExperienceSettingsType
>;

export type RechargeExperienceIntegrationDto = ExperienceIntegrationDto<
  "Recharge",
  RechargeGlobalSettingsDto,
  RechargeExperienceSettingsDto
>;

export type GrowLTVExperienceIntegrationDto = ExperienceIntegrationDto<
  "GrowLTV",
  GrowLTVGlobalSettingsDto,
  GrowLTVExperienceSettingsType
>;

export type OneClickUpsellExperienceIntegrationDto = ExperienceIntegrationDto<
  "OneClickUpsell",
  OneClickUpsellGlobalSettingsDto,
  OneClickUpsellExperienceSettingsDto
>;

export type UnknownExperienceIntegrationDto =
  | GoogleExperienceIntegrationDto
  | StayAiExperienceIntegrationDto
  | RechargeExperienceIntegrationDto
  | GrowLTVExperienceIntegrationDto
  | OneClickUpsellExperienceIntegrationDto;
